module.exports = __webpack_public_path__ + "static/media/icon-cust-service.c30a4ac2.svg";